'use strict';

angular.module('far.models.newsArchive', [])
    .service('NewsArchive', function ($log, $http) {
        var list = [];

        Object.defineProperty(this, 'list', {
            get: function () {
                $http.get(Routing.generate('api_get_pages'))
                    .then(function (response) {
                        response.data.forEach(function (routeData) {
                            list.push(routeData);
                        });
                    }, function errorCallback(response) {
                        $log.error(response);
                    });

                return list;
            }
        });

        this.new = function (data) {
            return new NewsArchive(data);
        };

        this.delete = function (route, callback) {
            return $http.delete(Routing.generate('api_delete_newsarchive', {newsArchive: route.id}))
                .then(function () {
                    route = null;

                    if (typeof callback == 'function') {
                        callback();
                    }
                }, function errorCallback(response) {
                    $log.error(response);
                });
        };

        this.restore = function (route) {
            return $http.patch(Routing.generate('api_patch_newsarchive', {id: route.id}))
                .then(function () {
                    return route = null;
                }, function errorCallback(response) {
                    $log.error(response);
                });
        };

        this.get = function (routeId, callback) {
            var route = new NewsArchive({});

            $http.get(Routing.generate('api_get_newsarchive', {newsArchive: routeId}))
                .then(function (response) {
                    route.update(response.data);

                    if (typeof callback == 'function') {
                        callback(route);
                    }
                }, function errorCallback(response) {
                    $log.error(response);
                });

            return route;
        };

        function NewsArchive(data) {
            angular.merge(this, data);

            Object.defineProperty(this, 'update', {
                enumerable: false,
                get: function () {
                    return function (data) {
                        angular.merge(this, data);

                        return this;
                    }
                }
            });

            Object.defineProperty(this, 'save', {
                enumerable: false,
                get: function () {
                    return function () {
                        var method = this.id ? 'put' : 'post',
                            url = this.id ?
                                Routing.generate('api_put_newsarchive', {newsArchive: this.id}) :
                                Routing.generate('api_post_newsarchive');

                        // TODO: Грязный хак
                        var data = angular.merge({}, this);

                        if ( angular.isObject( data.parent ) ) {
                            data.parent = data.parent.id;
                        }

                        if ( data.parent == 0 ) {
                            data.parent = null;
                        }

                        return $http[method](url, data);
                    }
                }
            });
        }
    });
